export const POPUP_BLOCKED_MESSAGE =
  "El navegador bloqueo la ventana del PDF. Habilite las ventanas emergentes para este sitio y vuelva a intentarlo.";

// pdfmake lanza un error cuando el navegador bloquea la ventana emergente; no debe interrumpir el guardado.
export const tryOpenReport = (openReport, data) => {
  try {
    openReport(data);
    return true;
  } catch (error) {
    return false;
  }
};
